'use client';

import React from 'react';

function CheckConfirm() {
  return (
    <svg
      height={100}
      width={100}
      viewBox="0 0 170 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="85.1372"
        cy="84.7499"
        r="84.2993"
        fill="#21BE79"
        fill-opacity="0.2"
      />
      <circle
        cx="85.1359"
        cy="84.7498"
        r="68.5695"
        fill="#21BE79"
        fill-opacity="0.3"
      />
      <circle
        opacity="0.4"
        cx="85.1382"
        cy="84.7498"
        r="55.2906"
        fill="#21BE79"
        fill-opacity="0.3"
      />
      <circle cx="85.1381" cy="84.7499" r="38.4506" fill="#21BE79" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.1361 74.5902C100.013 75.4672 100.013 76.8891 99.1361 77.766L81.9926 94.9096C81.1157 95.7865 79.6938 95.7865 78.8168 94.9096L71.1382 87.2313C70.2612 86.3544 70.2612 84.9325 71.1382 84.0555C72.0151 83.1785 73.437 83.1785 74.314 84.0554L80.4047 90.1459L95.9603 74.5902C96.8373 73.7133 98.2591 73.7133 99.1361 74.5902Z"
        fill="white"
      />
    </svg>
  );
}

export default CheckConfirm;
